import React from 'react';

import './loading.css';

const LoadingSpinner = () => <div className="loading-spinner" />;

export default LoadingSpinner;
